import { useEffect, useState } from 'react';
import { Button } from '@blum-rivendell/reactui';
import CompanyItem from './CompanyItem';
import { useContextAuth } from 'src/context/AuthContext';

const FormSelectCompany = () => {
  const { customers, selectCustomer, customer, onSignOut } = useContextAuth();

  useEffect(() => {
    if (customers.length === 1 && !customer) {
      selectCustomer(customers[0].id);
    }
  }, []);

  const [isLoadingSelectCustomer, setIsLoadingSelectCustomer] =
    useState<boolean>(false);

  const [selectedCompanyId, setSelectedCompanyId] = useState(
    customers[0]?.id ?? '',
  );

  const handleSelectCustomer = async () => {
    setIsLoadingSelectCustomer(true);
    await selectCustomer(selectedCompanyId);
  };

  // Fase 4 — el BE filtra de este listado las empresas en las que el empleado
  // tiene el acceso revocado. Si queda vacío significa que lo bloquearon en
  // todas las empresas que tenía asociadas, así que no hay a dónde entrar:
  // mostramos un mensaje accionable y la opción de cerrar sesión.
  if (customers.length === 0) {
    return (
      <div
        data-testid="select-company-empty-state"
        className="bl-flex bl-flex-col bl-justify-center bl-items-start bl-h-full bl-gap-4"
      >
        <h3 className="bl-text-3xl bl-font-bold bl-border-primary-green-100">
          No tienes acceso a ninguna empresa
        </h3>
        <p className="bl-text-neutral-dark-80">
          Si crees que es un error, contáctanos a{' '}
          <a
            href="mailto:operaciones@miblum.com"
            className="bl-text-primary-green-100 bl-underline"
          >
            operaciones@miblum.com
          </a>{' '}
          y lo revisamos.
        </p>
        <Button
          testId="btn-signout-select-company-empty"
          onClick={onSignOut}
          text="Cerrar sesión"
          className="bl-max-w-3 bl-self-start"
        />
      </div>
    );
  }

  return (
    <>
      <div className="bl-mt-[4%] lg:bl-mt-[7%] xl:bl-mt-[9%] bl-mb-4">
        <h3 className="bl-text-3xl bl-font-bold bl-border-primary-green-100 bl-mb-4">
          Selecciona la empresa
        </h3>
        <p className="bl-mb-4 bl-text-neutral-dark-80">
          Utiliza las opciones para escoger la empresa.
        </p>
        <div className="bl-grid bl-grid-cols-2 sm:bl-grid-cols-3 lg:bl-grid-cols-4 bl-gap-3 bl-pb-10 sm:bl-pb-0">
          {customers.map(({ id, name }) => (
            <CompanyItem
              key={id}
              name={name}
              isLoadingSelect={isLoadingSelectCustomer}
              isSelected={selectedCompanyId === id}
              onClickSelect={() => setSelectedCompanyId(id)}
            />
          ))}
        </div>
      </div>
      <Button
        testId="btn-continue-select-company"
        onClick={handleSelectCustomer}
        isLoading={isLoadingSelectCustomer}
        text="Continuar"
        className="bl-max-w-3 bl-fixed sm:bl-relative bl-self-center md:bl-self-end bl-bottom-3"
      />
    </>
  );
};

export default FormSelectCompany;
